import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import axios from 'axios';
import { BASEURL } from './config';

ReactDOM.render(
  <React.StrictMode>
    <div className="bg-gray-700">
      <App />
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);
axios.defaults.baseURL = BASEURL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(request => {
  // console.log(request);
  // Edit request config
  return request;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  // console.log(response);
  // Edit request config
  return response;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA;

serviceWorker.unregister();
